export const SITE_CONFIG_LOAD = "SITE_CONFIG_LOAD";

let pending = null;

// Loads /config.json (editable by the server admin after deployment). A missing
// or invalid file just results in an empty config.
export const loadSiteConfig = () => dispatch => {
  if (!pending) {
    pending = fetch("/config.json")
      .then(res => res.ok ? res.json() : {})
      .catch(() => ({}));
  }

  return pending.then(config => dispatch({
    type: SITE_CONFIG_LOAD,
    config: config && typeof config === "object" && !Array.isArray(config) ? config : {},
  }));
};
